import '@ids/style-card';
import './Card.css';

import { useState } from 'react';

import { IdsIcon } from '../../components/icon/Icon';
import type { Action, Content } from '../../global-types/Content';
import useTracking from '../../hooks/useTracking';
import { renderContent } from '../../utils/renderContent';

type CardProps = {
  content: Content;
  viewId: number | undefined;
  dispatchActionEvent: (action: Action, nextContent?: Content | null) => void;
};

function Card({ content, viewId, dispatchActionEvent }: CardProps) {
  const trackVisibilityElement = useTracking(content, viewId ?? undefined);
  const view = viewId ? content.contentViews?.find((cv) => cv.contentViewId === viewId) : undefined;
  const [disableButton, setDisableButton] = useState(false);
  if (view === undefined) return null;

  const { texts, linkStyledActions, buttonStyledActions } = renderContent({
    view,
    trackVisibilityElement,
    actionsConfig: {
      dispatchActionEvent,
      skipFirstAction: false,
      disableButton,
      setDisableButton,
    },
  });

  return (
    <div className={`if card elevated size-h-100p`}>
      {view.viewElements.media?.[0] && (
        <div className="if card-media">
          <img src={view.viewElements.media[0].url} alt={view.viewElements.media[0].alt} />
        </div>
      )}
      <div className="if card-content flex">
        <div className="card-container ">
          <div className="if flex flex-column mb-16">
            {view.viewElements.icons && (
              <div className="icon-wrapper">
                <IdsIcon name={view.viewElements.icons[0]} size={32} />
              </div>
            )}
            {texts}
          </div>
          <div className={`actions ${buttonStyledActions.length > 0 ? 'buttons' : ''}`}>
            {linkStyledActions}
            {buttonStyledActions.length > 0 && (
              <div className="if flex flex-column gap-16 buttons flex-center">{buttonStyledActions}</div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default Card;
